import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';
import { Text } from '@abyss/web/ui/Text';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getAllProvidersWithServiceType, getTranslatedText } from './utils';
import {
  headerContainerStyle,
  headerStyle,
  virtualCareListStyle,
  virtualCareListViewContainerStyle,
} from './VirtualCareList.styled';
import { default as VirtualCareListCard } from './VirtualCareListCard';

type Props = {
  sectionType?: string;
  virtualCareProviders: any;
  searchTerm?: string;
  isLoading: boolean;
  isMNR?: boolean;
  setIsVirtualCareListView: (a: boolean) => void;
  mobileScreen: boolean;
  serviceType: string;
  heading?: string;
};

export const VirtualCareList = ({
  virtualCareProviders,
  setIsVirtualCareListView,
  mobileScreen,
  searchTerm,
  serviceType,
  heading,
}: Props) => {
  const { t } = useTranslation();
  const translatedText = getTranslatedText(heading, searchTerm, t);
  const providers = getAllProvidersWithServiceType(virtualCareProviders);

  useEffect(
    () => () => {
      setIsVirtualCareListView(false);
    },
    [setIsVirtualCareListView]
  );

  return (
    <>
      <Flex
        alignItems="center"
        css={virtualCareListViewContainerStyle(mobileScreen)}
        data-testid="virtual-care-list-view-wrapper"
        direction="column"
      >
        <Flex
          alignItems="center"
          css={headerContainerStyle(mobileScreen)}
          data-auto-testid="header-container"
          data-testid="header-container"
          direction="column"
          justify="center"
        >
          <Flex
            alignItems="center"
            css={headerStyle(mobileScreen)}
            data-testid="header"
            direction="row"
            justify="space-between"
          >
            <Text
              css={{
                'abyss-text-root': {
                  margin: mobileScreen ? '0px' : '5px 0px 0px 8px',
                  display: 'flex',
                  fontSize: mobileScreen ? '14px' : '16px',
                  lineHeight: '18px',
                  fontWeight: '500 !important',
                  color: '#323333',
                },
              }}
              data-auto-testid="total-count-results-heading"
              data-testid="total-count-results-heading"
            >
              {providers.length > 0
                ? `${providers.length} ${t(
                    'VIRTUAL_CARE_PROVIDERS_BANNER.VIRTUAL_CARE'
                  )} ${t(`results for`)}`
                : `${t('No')} ${t(
                    'VIRTUAL_CARE_PROVIDERS_BANNER.VIRTUAL_CARE'
                  )} ${t(`results for`)}`}
              <Heading
                css={{
                  'abyss-heading-root': {
                    fontSize: mobileScreen
                      ? '14px !important'
                      : '16px !important',
                    lineHeight: '18px !important',
                    color: '#323333 !important',
                    width: 'auto',
                    paddingLeft: '4px',
                  },
                }}
                data-auto-testid="results-heading"
                data-testid="results-heading"
                display="h6"
                id="virtual-care-list-view-results"
                offset={4}
                textAlign="left"
              >
                {translatedText}
              </Heading>
            </Text>
          </Flex>
        </Flex>
        {providers.length > 0 && (
          <Flex
            alignItems="center"
            css={virtualCareListStyle(mobileScreen)}
            data-auto-testid="virtual-care-card-list"
            data-testid="virtual-care-card-list"
            direction="column"
            justify="center"
          >
            {providers.map((provider) => (
              <VirtualCareListCard
                key={provider.id}
                mobileScreen={mobileScreen}
                provider={provider}
                serviceType={serviceType || provider?.serviceType}
                virtualCareProviders={virtualCareProviders}
              />
            ))}
          </Flex>
        )}
      </Flex>
    </>
  );
};
